/**
 * Upload ceilings for post and comment media.
 *
 * Split by kind on purpose. Both screens used to check one 25 MB number for
 * everything, so raising the video limit would have raised it for images too —
 * and a 200 MB photo is never a real upload, it is a mistake worth catching.
 *
 * Video is 200 MB because a modern phone records roughly a megabyte per second:
 * 45 seconds of 1080p HEVC from an iPhone 15 Pro is already 50 MB, so 25 MB
 * turned away clips well under the app's own one-minute limit.
 *
 * Keep in step with the backend (PostVideoUploadMaxSizeResolver) and with PHP's
 * upload_max_filesize / post_max_size on the server — the smallest of the three
 * is what members actually experience.
 */
export const MAX_IMAGE_BYTES = 25 * 1024 * 1024;
export const MAX_VIDEO_BYTES = 200 * 1024 * 1024;

/** For messages: "fino a 200 MB". */
export const maxMbLabel = (bytes) => `${Math.round(bytes / (1024 * 1024))} MB`;

/** The ceiling that applies to a given file. */
export const maxBytesForFile = (file) =>
  String(file?.type || "").startsWith("video/") ? MAX_VIDEO_BYTES : MAX_IMAGE_BYTES;
